import {autorun, extendObservable, action, runInAction} from 'mobx';
import firebase from 'firebase/app';
import 'firebase/auth';
import firebaseConfig from '../../configs/firebaseConfig';

export class FirebaseStore {
  constructor() {
    extendObservable(this, {
      isInitialize: false,
    });

    firebase.initializeApp(firebaseConfig);
    autorun(() => this.init());
  }

  @action
  init() {
    firebase.auth().onAuthStateChanged(() => {
      runInAction(() => {
        this.isInitialize = true;
      });

      const connectedRef = firebase.database().ref('.info/connected');
      connectedRef.on('value', snap => {
        if (snap.val() === true) {
          console.log('Firebase connected');
        } else {
          console.log('Firebase not connected');
        }
      });
    });
  }
}
